import api from '../token';

export const AlterEstoque = async (produto) => {
  try {
    const response = await api.post('/closeEstoque', produto);
    return response.data;
  } catch (error) {
    
    return { success: false, message: error.message };
  }
};